module.exports = __webpack_public_path__ + "img/footer_code.f20f2465.png";